module.exports = __webpack_public_path__ + "static/media/prev.5c5d9549.svg";